<template>
  <el-button type="primary" size="small" @click="handleLogin">免密登录</el-button>
</template>

<script>
import { postAgentSafeLogin } from "@/api/sso/agent";

export default {
  props: {
    id: String
  },
  data() {
    return {};
  },
  methods: {
    handleLogin() {
      postAgentSafeLogin({ id: this.id }).then(res => {
        const a = document.createElement("a");
        if (res.data.url) {
          a.href = `http://${res.data.url}?token=${res.data.token}`;
        } else {
          a.href = `${window.location.origin}?token=${res.data.token}`;
        }
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(() => {
        // 业务错误已由 SSO 拦截器 ElMessage 提示
      });
    }
  }
};
</script>

<style>

</style>
